<template>
  <el-dialog custom-class="custom-dialog" :title="title" :visible.sync="visible" :width="width"
             :close-on-click-modal="false"
             center
             :before-close="onClose">
    <slot></slot>
    <slot name="btn">
      <span slot="footer" class="dialog-footer">
        <el-button round @click="onClose">取消</el-button>
        <el-button type="primary" round @click="onConfirm">{{ okText }}</el-button>
      </span>
    </slot>

  </el-dialog>
</template>

<script>
export default {
  name: 'Dialog',
  props: {
    title: {
      type: String,
      default: ''
    },
    width: {
      type: String,
      default: '800px'
    },
    okText: {
      type: String,
      default: '确定'
    }
  },
  data() {
    return {
      visible: false
    }

  },
  mounted() {

  },
  methods: {
    onOpen() {
      this.visible = true
    },
    onClose() {
      this.$emit('close')
      this.visible = false
    },
    onConfirm() {
      this.$emit('confirm')
    }
  }
}
</script>

<style>
/* 或者尝试这种写法 */
.el-dialog.custom-dialog {
  border-radius: 10px !important;

}

.el-dialog__body {
  padding: 20px !important;
}


.el-dialog__footer {
  text-align: center;
}
</style>
